import { type FC, type ReactNode, type ReactElement } from 'react';
import classnames from 'classnames';

import { useIntl, type MessageDescriptor } from 'dibs-react-intl';
import { type HeadingType } from 'dibs-controlled-heading/exports/HeadingLevel';
import {
    ResponsiveExpandingContentProvider,
    ResponsiveExpandingContentTrigger,
    useResponsiveExpandingContent,
} from './ResponsiveExpandingContent';

import styles from './FormattedExpandingSection.scss';

type MessageParameters = Record<string, (params: ReactNode[]) => ReactElement>;

// this is a separate component bc useResponsiveExpandingContent must be scoped
// to a child of ResponsiveExpandingContentProvider.
const Body: FC<{ descriptor: MessageDescriptor; params?: MessageParameters }> = ({
    descriptor,
    params,
}) => {
    const [ref, { style, className }] = useResponsiveExpandingContent();
    const { formatMessage } = useIntl();
    return (
        <p ref={ref} style={style} className={classnames(styles.sectionBody, className)}>
            {formatMessage(descriptor, params)}
        </p>
    );
};

export const FormattedExpandingSection: FC<{
    headingDescriptor: MessageDescriptor;
    bodyDescriptor: MessageDescriptor;
    bodyParams?: MessageParameters;
    Heading: HeadingType;
    deviceType?: string;
}> = ({ headingDescriptor, bodyDescriptor, bodyParams, Heading, deviceType }) => {
    const { formatMessage } = useIntl();
    return (
        <div className={styles.section}>
            <ResponsiveExpandingContentProvider deviceType={deviceType}>
                <Heading className={styles.sectionHeading}>
                    <ResponsiveExpandingContentTrigger>
                        {formatMessage(headingDescriptor)}
                    </ResponsiveExpandingContentTrigger>
                </Heading>
                <Body descriptor={bodyDescriptor} params={bodyParams} />
            </ResponsiveExpandingContentProvider>
        </div>
    );
};
